var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import ClientSearch from "../../../components/Generic/ClientSearch";
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import clientDi from "@frameworks/salesjourney/components/Features/ClientDetails/di/serviceLocator";
import { FileUploadSection } from "../../../../shared-library/components/fileupload/fileUploadSection";
import InputField from "@frameworks/web/components/generic/inputField";
import { pan } from "@frameworks/web/utils/regex";
import advisoryDI from "@frameworks/salesjourney/components/Features/Advisory/di/servicelocator";
import { debounce } from "@frameworks/salesjourney/utils/genericMethods";
var _ = require("lodash");
var UploadPortfolio = function (props) {
    var _a;
    var _b = __read(useState({}), 2), casFileUploadPayload = _b[0], setCasFileUploadPayload = _b[1];
    var _c = __read(useState({
        pan: "",
        searchText: "",
        file: "",
        uccCode: "",
    }), 2), error = _c[0], setError = _c[1];
    var _d = __read(useState(""), 2), responseMessage = _d[0], setResponseMessage = _d[1];
    var _e = __read(useState(false), 2), isSuccessText = _e[0], setIsSuccessText = _e[1];
    var _f = __read(useState(false), 2), resetFileUpload = _f[0], setResetFileUpload = _f[1];
    var _g = __read(useState([]), 2), searchedClients = _g[0], setSearchedClients = _g[1];
    var _h = __read(useState(false), 2), isPanFieldReadOnly = _h[0], setIsPanFieldReadOnly = _h[1];
    var _j = __read(React.useState(""), 2), searchText = _j[0], setSearchText = _j[1];
    var validationError = function (field, value) {
        var _a;
        setError(__assign(__assign({}, error), (_a = {}, _a[field] = value, _a)));
    };
    var clientSearchData = useSelector(function (state) { return state.Clients.ClientSearch.reducersData.data; });
    var clientSearchLoader = useSelector(function (state) { return state.Clients.ClientSearch.commonData.loader; });
    var handleSetFileInfo = function (fileDetails) {
        var base64DataSplit = fileDetails === null || fileDetails === void 0 ? void 0 : fileDetails.base64Data.split(",");
        if ((fileDetails === null || fileDetails === void 0 ? void 0 : fileDetails.docFile) && (base64DataSplit === null || base64DataSplit === void 0 ? void 0 : base64DataSplit.length) > 1) {
            var fileData_1 = {
                file: base64DataSplit[1],
                fileName: fileDetails.docFile,
            };
            validationError("file", "");
            setCasFileUploadPayload(function (prevCasFileUploadPayload) { return (__assign(__assign({}, prevCasFileUploadPayload), fileData_1)); });
        }
        else {
            validationError("file", "Please select file");
        }
    };
    useEffect(function () {
        if ((clientSearchData === null || clientSearchData === void 0 ? void 0 : clientSearchData.length) > 0 && searchText)
            setSearchedClients(clientSearchData);
    }, [clientSearchData]);
    var getClientSearchData = function (searchText) {
        setSearchedClients([]);
        clientDi.clients.getClientSearchData({ searchText: searchText });
    };
    var onSubmit = function () {
        if ((props === null || props === void 0 ? void 0 : props.isPortfolioModal) == true &&
            (casFileUploadPayload === null || casFileUploadPayload === void 0 ? void 0 : casFileUploadPayload.pan) &&
            (casFileUploadPayload === null || casFileUploadPayload === void 0 ? void 0 : casFileUploadPayload.clientId)
        //&& casFileUploadPayload?.uccCode
        ) {
            setResponseMessage("");
            setIsSuccessText(false);
            advisoryDI.advisory
                .syncNuvamaPortfolio({
                pan: casFileUploadPayload.pan,
                clientId: casFileUploadPayload.clientId,
                uccCode: casFileUploadPayload.uccCode,
            })
                .then(function (resp) {
                setSearchText("");
                setCasFileUploadPayload({});
                if ((resp === null || resp === void 0 ? void 0 : resp.isSuccess) == null && (resp === null || resp === void 0 ? void 0 : resp.message) == null) {
                    setResponseMessage("Something went wrong.please try again after sometime.");
                    setIsSuccessText(false);
                }
                else {
                    setResponseMessage(resp === null || resp === void 0 ? void 0 : resp.message);
                    setIsSuccessText(resp === null || resp === void 0 ? void 0 : resp.isSuccess);
                    props === null || props === void 0 ? void 0 : props.setShowPortfolioModal(false);
                    props === null || props === void 0 ? void 0 : props.getCASUploadHistory(props === null || props === void 0 ? void 0 : props.finalFilterState);
                }
                props.setFileUploading(false);
            })
                .catch(function (error) {
                setResponseMessage("Something went wrong.please try again after sometime.");
                setIsSuccessText(false);
            });
        }
        else {
            if ((casFileUploadPayload === null || casFileUploadPayload === void 0 ? void 0 : casFileUploadPayload.pan) &&
                (casFileUploadPayload === null || casFileUploadPayload === void 0 ? void 0 : casFileUploadPayload.file) &&
                (casFileUploadPayload === null || casFileUploadPayload === void 0 ? void 0 : casFileUploadPayload.fileName) &&
                (casFileUploadPayload === null || casFileUploadPayload === void 0 ? void 0 : casFileUploadPayload.clientId)) {
                props.setFileUploading(true);
                advisoryDI.advisory
                    .uploadCASpdf(__assign({}, casFileUploadPayload))
                    .then(function (res) {
                    setCasFileUploadPayload({});
                    setSearchText("");
                    setResponseMessage(res === null || res === void 0 ? void 0 : res.message);
                    setIsSuccessText(res === null || res === void 0 ? void 0 : res.isSuccess);
                    setResetFileUpload(true);
                    props.setFileUploading(false);
                    if (res === null || res === void 0 ? void 0 : res.isSuccess) {
                        props === null || props === void 0 ? void 0 : props.setShowModal(false);
                    }
                })
                    .catch(function (error) {
                    props.setFileUploading(false);
                });
            }
            else if (!(casFileUploadPayload === null || casFileUploadPayload === void 0 ? void 0 : casFileUploadPayload.fileName)) {
                validationError("file", "Please select file.");
            }
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "w-100 upload-portfolio-container" },
            React.createElement("div", { className: "upload-portfolio-fields" },
                React.createElement("label", { className: "DMSanN_16_400 txt_primaryGrey mb-1" }, "Search Client"),
                React.createElement("div", { className: "search-input" },
                    React.createElement(InputField, { prefix: React.createElement("i", { className: "edel-icon-search1" }), autoFocus: true, onChangeEvent: function (e) {
                            setResetFileUpload(false);
                            setSearchText(e.target.value);
                            setError(__assign(__assign({}, error), { searchText: "" }));
                            setResponseMessage("");
                            setIsPanFieldReadOnly(false);
                            if (e.target.value.length > 3) {
                                debounce(function () {
                                    getClientSearchData(e.target.value);
                                });
                            }
                        }, defaultValue: searchText !== null && searchText !== void 0 ? searchText : "", onBlur: function (error, event) {
                            if (error.required)
                                validationError(event.target.name, "This field is Required");
                            else
                                validationError(event.target.name, "");
                        }, errorText: error === null || error === void 0 ? void 0 : error.searchText, placeholder: "Search Client", id: "searchText", name: "searchText", required: true, autoComplete: "off", lable: false, showLabel: false, placeholderClassName: "DMSanN_16_400 d-flex", className: "custom-form-control" })),
                searchedClients.length > 0 && searchText && (React.createElement("div", { className: "px-0 position-absolute bg_white clientsearch-popup header w-100" },
                    React.createElement(ClientSearch, { clientSearchList: searchedClients, loader: clientSearchLoader, setCallbackFunction: function (data) {
                            setSearchText(data.clientName);
                            console.log("client data", data);
                            if (data === null || data === void 0 ? void 0 : data.pan) {
                                setIsPanFieldReadOnly(true);
                                validationError("pan", "");
                            }
                            setCasFileUploadPayload(__assign(__assign({}, casFileUploadPayload), { pan: data === null || data === void 0 ? void 0 : data.pan, clientId: data === null || data === void 0 ? void 0 : data.accountCode }));
                            if ((props === null || props === void 0 ? void 0 : props.isPortfolioModal) == true) {
                                setCasFileUploadPayload(function (casFileUploadPayload) {
                                    casFileUploadPayload.uccCode = data === null || data === void 0 ? void 0 : data.uniqueCode;
                                    return casFileUploadPayload;
                                });
                            }
                            setSearchedClients([]);
                        } }))),
                (props === null || props === void 0 ? void 0 : props.isPortfolioModal) == false && (React.createElement("div", { className: "upload-cas-container" },
                    React.createElement("label", { className: "DMSanN_16_400 txt_primaryGrey mb-1" }, "Upload File"),
                    React.createElement("div", { className: "upload-cas" },
                        React.createElement(FileUploadSection, { reset: resetFileUpload, disableCross: false, fileType: ["pdf"], onSubmit: function (fileinfo) {
                                handleSetFileInfo(fileinfo);
                            }, fileSizeInMB: "5MB", fileSize: 5242880 })),
                    (error === null || error === void 0 ? void 0 : error.file) && (React.createElement("p", { className: "DMSansNormal_12_400 txt_bloodRed py-1" }, "Please select file")))),
                React.createElement("div", { className: "upload-pan" },
                    React.createElement("label", { className: "DMSanN_16_400 txt_primaryGrey mb-1" }, "PAN Number"),
                    React.createElement(InputField, { onChangeEvent: function (e) {
                            setError(__assign(__assign({}, error), { pan: "" }));
                            setResponseMessage("");
                            setCasFileUploadPayload(__assign(__assign({}, casFileUploadPayload), { pan: e.target.value.toLocaleUpperCase() }));
                        }, defaultValue: (_a = casFileUploadPayload === null || casFileUploadPayload === void 0 ? void 0 : casFileUploadPayload.pan) !== null && _a !== void 0 ? _a : "", pattern: pan, onBlur: function (error, event) {
                            if (error.required)
                                validationError(event.target.name, "This field is Required");
                            else if (!error.pattern)
                                validationError(event.target.name, "Enter 10 digits valid PAN Number");
                            else
                                validationError(event.target.name, "");
                        }, errorText: error.pan, placeholder: "Enter your PAN", id: "pan", name: "pan", required: true, autoComplete: "off", showLabel: false, readOnly: isPanFieldReadOnly, placeholderClassName: "floating-label ", className: "custom-form-control" }))),
            React.createElement("div", { className: "response-message" },
                React.createElement("p", { className: "DMSansNormal_12_400  ".concat(isSuccessText ? "txt_green" : "txt_bloodRed") }, responseMessage)),
            React.createElement("div", { className: "upload-portfolio-buttons w-100 d-flex" },
                React.createElement("button", { disabled: (error === null || error === void 0 ? void 0 : error.pan) ||
                        props.fileUploading ||
                        (error === null || error === void 0 ? void 0 : error.file) ||
                        (props === null || props === void 0 ? void 0 : props.isPortfolioModal) == true
                        ? !(casFileUploadPayload === null || casFileUploadPayload === void 0 ? void 0 : casFileUploadPayload.clientId)
                            ? true
                            : false
                        : !(casFileUploadPayload === null || casFileUploadPayload === void 0 ? void 0 : casFileUploadPayload.clientId) || !(casFileUploadPayload === null || casFileUploadPayload === void 0 ? void 0 : casFileUploadPayload.file)
                            ? true
                            : false, className: "upload-portfolio-button submit-button bg-midnight-blue DMSanN_14_400", onClick: onSubmit }, (props === null || props === void 0 ? void 0 : props.fileUploading) ? "uploading ..." : "Submit"),
                React.createElement("button", { disabled: props === null || props === void 0 ? void 0 : props.fileUploading, type: "button", className: "upload-portfolio-button close-button DMSanN_14_400", onClick: function () {
                        if ((props === null || props === void 0 ? void 0 : props.isPortfolioModal) == true) {
                            props === null || props === void 0 ? void 0 : props.setShowPortfolioModal(false);
                        }
                        else {
                            props.setShowModal(false);
                            props === null || props === void 0 ? void 0 : props.setFileUploading(false);
                        }
                    } }, "Cancel")))));
};
export default UploadPortfolio;
